import SitemapLinksBlock from './SitemapLinksBlock';

export default SitemapLinksBlock;
